import InsertNoteButton from '@/features/common/components/InsertNoteFormContent/Switcher/parts/Button'
import Note from '@/features/common/components/InsertNoteFormContent/Switcher/parts/Note'
import { FC } from 'react'

interface NoteSwitcherProps {
    confirmedNote: string | null
    onEdit: () => void
}

const NoteSwitcher: FC<NoteSwitcherProps> = ({ confirmedNote, onEdit }) => {
    if (confirmedNote) return <Note onEdit={onEdit}>{confirmedNote}</Note>

    return <InsertNoteButton onPress={onEdit} />
}

export default NoteSwitcher
